import { render, staticRenderFns } from "./areaCorrect.vue?vue&type=template&id=f5f6fd4e&scoped=true"
import script from "./areaCorrect.vue?vue&type=script&lang=js"
export * from "./areaCorrect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f6fd4e",
  null
  
)

export default component.exports